import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { Redirect, useParams } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons
import MailOutline from "@material-ui/icons/MailOutline";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import CustomInput from "components/CustomInput/CustomInput.js";

import View from "./View";
import ViewDetailList from "./ViewDetailList";

import styles from "assets/jss/material-dashboard-pro-react/views/formsStyle.js";

import { bookingApi } from "functions/apis";

const useStyles = makeStyles(styles);

export default function Reject(props) {
  const source = useRef(new AbortController());
  const { id } = useParams();
  const [
    agentBookingCancellation,
    setAgentBookingCancellation
  ] = React.useState(null);

  useEffect(() => {
    bookingApi
      .get("/AgentBookingCancellations/" + id, {
        signal: source.current.signal
      })
      .then(data => setAgentBookingCancellation(data))
      .catch(error => console.log(error));

    return () => source.current.abort();
  }, [id]);

  const handleRejectReasonChanged = e =>
    setRejectReason(e.target.value === "" ? null : e.target.value);

  const [rejectReason, setRejectReason] = React.useState(null);
  const [redirect, setRedirect] = React.useState(false);
  const [disabled, setDisabled] = React.useState(false);
  const handleSubmit = e => {
    e.preventDefault();
    setDisabled(true);
    bookingApi
      .post(
        "/AgentBookingCancellations/Reject",
        {
          id: id,
          rejectReason: rejectReason
        },
        {
          signal: source.current.signal
        }
      )
      .then(() => setRedirect(true))
      .catch(error => {
        console.log(error);
        setDisabled(false);
      });
  };

  const classes = useStyles();
  return (
    agentBookingCancellation !== null &&
    (redirect ? (
      <Redirect to="/admin/AgentBookingCancellations/Submitted" />
    ) : (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="rose" icon>
              <CardIcon color="rose">
                <MailOutline />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>REJECT CANCELLATION</h4>
            </CardHeader>
            <CardBody>
              <p>
                <i>*Please review before REJECT the Request.</i>
              </p>
              <form onSubmit={handleSubmit}>
                <CustomInput
                  labelText="Reject Reason"
                  formControlProps={{
                    fullWidth: true
                  }}
                  inputProps={{
                    onChange: handleRejectReasonChanged,
                    value: rejectReason === null ? "" : rejectReason
                  }}
                />
                <Button onClick={() => props.history.goBack()} value="Cancel">
                  CANCEL
                </Button>
                <Button
                  disabled={disabled}
                  color="rose"
                  type="submit"
                  value="Submit"
                >
                  REJECT
                </Button>
              </form>
            </CardBody>
          </Card>
          <View
            agentBookingCancellation={agentBookingCancellation}
            history={props.history}
          />
          <ViewDetailList agentBookingCancellation={agentBookingCancellation} />
        </GridItem>
      </GridContainer>
    ))
  );
}

Reject.propTypes = {
  history: PropTypes.object
};
